// PostHog wird nur geladen, wenn der Nutzer Analytics-Cookies akzeptiert hat.
// Key aus ENV: REACT_APP_POSTHOG_KEY (bei Bedarf setzen, sonst kein Tracking)
let loaded = false;

export function hasAnalyticsConsent() {
  try {
    const raw = localStorage.getItem("cookie-consent");
    if (!raw) return false;
    return !!JSON.parse(raw).analytics;
  } catch {
    return false;
  }
}

export async function initAnalytics() {
  if (loaded || !hasAnalyticsConsent()) return;
  const key = process.env.REACT_APP_POSTHOG_KEY;
  if (!key) return;
  const { default: posthog } = await import("posthog-js");
  posthog.init(key, {
    api_host: process.env.REACT_APP_POSTHOG_HOST || "https://eu.i.posthog.com",
    person_profiles: "identified_only",
    capture_pageview: true,
  });
  loaded = true;
}
